module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('workbench-w-canvas-slot', {
    attrs: {
      "loading": _vm.loading,
      "metrics": _vm.toolbarMetrics,
      "target-name": _vm.targetName,
      "activated": _vm.activated,
      "header-menu": _vm.dynamicHeaderMenu,
      "showQuickAddAttributes": _vm.showQuickAddAttributes
    }
  }, [(_vm.isTargetEmpty && !_vm.loading) ? [_c('div', {
    staticClass: "workbench__empty-target"
  }, [(_vm.isTargetEmpty) ? _c('h3', [_vm._v("Select a Program by Searching or Browsing from the right panel.")]) : _vm._e()])] : [_c('workbench-row', {
    ref: "viewership",
    style: ({
      height: _vm.viewershipRowHeight
    })
  }, [_c('audience-size', {
    staticClass: "workbench__audience workbench__canvas-block",
    attrs: {
      "size": _vm.audienceSize
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "workbench__canvas-block workbench__viewership"
  }, [_c('viewership', {
    attrs: {
      "networks": _vm.networks,
      "show-filter": false,
      "viewership-data": _vm.historicalViewership
    }
  })], 1)], 1), _vm._v(" "), (_vm.selectedNetworksDayParts.length > 0) ? _c('workbench-row', [_c('day-parts', {
    staticClass: "workbench__day-parts workbench__canvas-block",
    attrs: {
      "viewership-data": _vm.historicalViewership,
      "selected-networks": _vm.selectedNetworksDayParts,
      "networks": _vm.networks,
      "day-parts-config": _vm.dayPartsConfig
    },
    on: {
      "close": _vm.clearSelectedNetworks
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('workbench-row', {
    ref: "universe",
    staticClass: "workbench__universe",
    style: ({
      height: _vm.universeRowHeight
    })
  }, [_c('universe-stability', {
    staticClass: "workbench__canvas-block",
    attrs: {
      "universe": _vm.universeData,
      "hide-stability-flag": true
    }
  })], 1)], _vm._v(" "), _c('confirm-modal', {
    ref: "confirmModal"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-128ac01b","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/workbench/AD/Ad.vue
// module id = 2001
// module chunks = 0